import * as React from 'react';
import { RouteComponentProps } from 'react-router';

export class ErrorView extends React.Component<RouteComponentProps<{}>> {
    render() {
        const { state } = this.props.location;

        let body = <h3>An unexpected error has occurred.</h3>;

        if (state) {
            const code = state.code ? state.code : 404;

            let text = 'An error occurred.';

            switch (Number(code)) {
                case 403:
                    text = `You do not have the proper permissions to view the requested page.`;
                    break;
                case 404:
                    const entityType = state.entityType ? state.entityType : 'page';
                    text = `The ${entityType} you requested could not be found.`;
                    break;
                default:
                    text = 'The page you requested could not be found.';
            }

            body = (
                <div>
                    <h1>{code}</h1>
                    <h3>{text}</h3>
                </div>
            );
        }

        return (
            <div className="container error">
                {body}
                <a href="/home">Return Home</a>
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/components/ErrorView.tsx